




































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY as PARENT_STORE_KEY } from '../_store';
import { STORE_KEY, store } from './_store';
import Attachments from '@/components/Controls/Attachments.vue';
import moment from 'moment';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(PARENT_STORE_KEY, [
      'relatedFactsList'
    ]),
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta', 'storages'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      plan_id: { required },
      quantity: { required },
      container_id: { required },
      provider_id: { required },
      fact_weight: { required },
      comment: {  },
    }
    return {
      form: rules
    }
  },
  components: {
    Attachments
  }
})
export default class ShiftVDPFactForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;
  @Prop({ type: String }) documentId!: any;

  document!: any
  form!: any
  relatedFactsList!: any

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  get newDay(){
    return moment().hours()  < 9;
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    // this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  addItem(storage_id: any) {
    this.$store.dispatch(`${STORE_KEY}/addItem`, {storage_id});
  }

  removeItem(index: any) {
    this.$store.dispatch(`${STORE_KEY}/removeItem`, index);
  }

  addAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addAttachments`, {newValue: file});
  }

  removeFile( idx: number, data: any) {
    this.form.attachments.splice(idx, 1)
  }

  changeStorageValue(index: number, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeStorageValue`, {
      index, field, newValue: value
    });
  }

  onContainerChange($event: any) {
    if ($event && $event.label) {
      this.changeValue('container_weight', $event.weight);
      this.changeValue('container_tare_weight', $event.tare_weight);
    }
  }

  prefilterShiftPlans(item: any, index: number) {
    const existsList = this.relatedFactsList.map((item: any) => {
      return item.plan_id
    })
    return !existsList.includes(item.id)
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

